var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"group__level-wrapper"},_vm._l((_vm.preparedLevels),function(level){return _c('Level',{key:("level-" + (level.uuid)),attrs:{"level":level,"progress":_vm.progress,"levelMedia":_vm.preparedMedia}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }